export default "__VITE_ASSET__mLp_SJQ2__"